const LIFETIME_PLAN_DISPLAY_NAMES = {
  '1 site lifetime': 'Individual Lifetime',
  'one site lifetime': 'Individual Lifetime',
  '3 site lifetime': 'Growth Lifetime',
  'three site lifetime': 'Growth Lifetime',
  '10 site lifetime': 'Scale Lifetime',
  'ten site lifetime': 'Scale Lifetime',
}

export function formatPlanDisplayName(planName) {
  if (typeof planName !== 'string') return planName

  const normalized = planName.trim().toLowerCase().replace(/\s+/g, ' ')

  return LIFETIME_PLAN_DISPLAY_NAMES[normalized] || planName
}

export function getDisplayPlanName(plan, fallback = '') {
  const planName = plan?.planName || plan?.name || plan?.planType || plan?.plan || fallback

  return formatPlanDisplayName(planName)
}
